import { render, staticRenderFns } from "./PDFUploader.vue?vue&type=template&id=d482e304&scoped=true&"
import script from "./PDFUploader.vue?vue&type=script&lang=js&"
export * from "./PDFUploader.vue?vue&type=script&lang=js&"
import style0 from "./PDFUploader.vue?vue&type=style&index=0&id=d482e304&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d482e304",
  null
  
)

export default component.exports